import styled from "styled-components";
import { DatePicker, Select } from "antd";

const { RangePicker } = DatePicker;

export const StyledSelect = styled(Select)`
	/* Frame 148 */
	position: absolute;
	box-sizing: border-box;
	margin-top: -10px;
	/* Auto layout */
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	/* padding: 5px 10px; */
	gap: 10px;

	width: 175px;
	height: 38px;
`;

export const Wrapper = styled.div`
	min-width: 100%;
	height: 80%h;
	background-color: #f7f7f7;
	padding: 16px 29px 16px 0px;
`;

export const Header = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
`;

export const StyledRangePicker = styled(RangePicker)`
	width: 250px;
	color: #ffffff;
`;

export const StyledHeadTitle = styled.label`
	font-family: 'Inter';
	font-size: 25px;
	font-weight: 600;
	line-height: 28px;
	text-align: left;
	color: #333333;
`;

export const StyledCaledarWrapper = styled.div`
	display: flex;
	gap: 10px;
	color: #ffffff;

	& svg {
		width: 20px;
		height: 20px;
	}
	.ant-picker {
		background-color: #a7388e;
		font-family: Inter;
		font-size: 14px;
		font-weight: 400;
		line-height: 28px;
		text-align: center;
		color: #ffffff;
	}

	.ant-picker .ant-picker-input,
	.ant-picker .ant-picker-range,
	.ant-picker .ant-picker-input-active .ant-picker-input-placeholder {
		display: flex;
		flex-direction: row-reverse;
		font-family: 'Inter';
		font-size: 14px;
		font-weight: 400;
		line-height: 28px;
		color: #ffffff;
	}

	.ant-picker .ant-picker-input .ant-picker-input-active {
		color: #ffffff !important;
	}

	.ant-picker .ant-picker-input .ant-picker-input-placeholder {
		color: #ffffff !important;
	}

	.ant-picker .ant-picker-input span.ant-picker-suffix,
	.ant-picker.ant-picker-range span.ant-picker-suffix {
		order: -1;
		margin-left: 0;
		margin-right: 10px; /* Для отступа иконки от текста */
		color: #ffffff;
	}

	.ant-picker.ant-picker-range.ant-picker-range-separator {
		color: #ffffff !important;
		/* display: none; */
	}

	.ant-picker-range-separator > span {
		color: #ffffff !important; /* Замените #ваш_цвет на нужный код цвета */
	}

	.ant-picker-clear {
		color: #ffffff !important; /* Замените #ваш_цвет на нужный код цвета */
	}

	.ant-picker .ant-picker-clear {
		position: absolute;
		right: 217px;
		/* color: #ffffff !important; */
	}
`;

export const StyledCalendarMemo = styled.div`
	display: flex;
	width: 220px;
	height: 40px;
	gap: 10px;
	background-color: #e9e9e9;
	border-radius: 5px 0px 0px 0px;
	opacity: 0px;
	align-items: center;
	justify-content: center;
	font-family: 'Inter';
	font-size: 14px;
	font-weight: 400;
	line-height: 28px;
	text-align: left;
	color: #333333;
`;

export const ChartsWrapper = styled.div`
	height: 470px;
	width: 100%;
	padding: 30px 30px 70px;
	background-color: #fff;
	border-radius: 5px;
`;
